import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_POPOVER } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import {
  LineItemFulfilmentCustomerDetailsViewProps,
  LineItemFulfilmentCustomerDetailsView as LineItemFulfilmentCustomerDetailsViewUnified,
} from './LineItemFulfilmentCustomerDetailsView'
import { LineItemFulfilmentCustomerDetailsViewLegacy } from './LineItemFulfilmentCustomerDetailsViewLegacy'

export const LineItemFulfilmentCustomerDetailsView: React.FC<LineItemFulfilmentCustomerDetailsViewProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_POPOVER
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemFulfilmentCustomerDetailsViewUnified {...props} />
  ) : (
    <LineItemFulfilmentCustomerDetailsViewLegacy {...props} />
  )
}

export type { LineItemFulfilmentCustomerDetailsViewProps }
